'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _ConfigGlobal = require('../config/ConfigGlobal');

var _ConfigGlobal2 = _interopRequireDefault(_ConfigGlobal);

var _UtilLodash = require('../utils/UtilLodash');

var _BaseInputSearch = require('./BaseInputSearch');

var _BaseInputSearch2 = _interopRequireDefault(_BaseInputSearch);

require('./css/basefilter.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BaseFilter = function (_React$Component) {
    (0, _inherits3.default)(BaseFilter, _React$Component);

    function BaseFilter(props) {
        (0, _classCallCheck3.default)(this, BaseFilter);

        var _this = (0, _possibleConstructorReturn3.default)(this, (BaseFilter.__proto__ || (0, _getPrototypeOf2.default)(BaseFilter)).call(this, props));

        _this.debouncer = _lodash.debounce;

        _this.handleInputChange = function (value) {
            _this.onFilterChange(value);
        };

        _this.state = {
            filterText: ''
        };
        _this.onFilterChange = _this.debouncer(_this.onFilterChange.bind(_this), props.filterDelay);
        _this.renderComponent = _this.renderComponent.bind(_this);
        _this.renderFilter = _this.renderFilter.bind(_this);
        _this.dataTestID = 'base-filter';
        return _this;
    }

    (0, _createClass3.default)(BaseFilter, [{
        key: 'onFilterChange',
        value: function onFilterChange() {}
    }, {
        key: 'getDataTestId',
        value: function getDataTestId() {
            var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'component';

            return this.props.dataTestID || this.dataTestID + '-' + prefix;
        }
    }, {
        key: 'getSubDataTestId',
        value: function getSubDataTestId() {
            var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            return this.getDataTestId() + '-' + prefix;
        }
    }, {
        key: 'renderFilter',
        value: function renderFilter() {
            var _props = this.props,
                placeholder = _props.placeholder,
                iconAlign = _props.iconAlign,
                filterIcon = _props.filterIcon,
                iconType = _props.iconType;

            return _react2.default.createElement(
                'div',
                { className: 'base-filter-input-wrapper' },
                _react2.default.createElement(_BaseInputSearch2.default, {
                    placeholder: placeholder,
                    iconAlign: iconAlign,
                    iconCls: filterIcon,
                    iconType: iconType || _lodash2.default.get(_ConfigGlobal2.default, 'iconType.search'),
                    onChange: this.handleInputChange,
                    dataTestID: this.getSubDataTestId('search')
                })
            );
        }
    }, {
        key: 'renderComponent',
        value: function renderComponent() {}
    }, {
        key: 'render',
        value: function render() {
            var filter = this.props.filter;


            return _react2.default.createElement(
                'div',
                {
                    'data-testid': this.getDataTestId(),
                    className: 'base-filter'
                },
                filter && this.renderFilter(),
                this.renderComponent()
            );
        }
    }], [{
        key: 'filterString',
        value: function filterString(array, text, fields) {
            var properties = [];
            var searchString = (0, _UtilLodash.replaceUnicode)(text);
            var regExp = new RegExp(searchString, 'i');
            if (typeof fields === 'string') {
                properties.push(fields);
            } else {
                properties = properties.concat(fields);
            }
            var found = false;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                var _loop = function _loop() {
                    var property = _step.value;

                    found = found || _lodash2.default.filter(array || [], function (item) {
                        return regExp.test((0, _UtilLodash.replaceUnicode)(item.hasOwnProperty(property) ? item[property] : ''));
                    });
                };

                for (var _iterator = (0, _getIterator3.default)(properties), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    _loop();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return found;
        }
    }]);
    return BaseFilter;
}(_react2.default.Component);

BaseFilter.defaultProps = {
    placeholder: 'Search...',
    filter: true,
    filterDelay: 300,
    filterIcon: '',
    iconType: "search"
};

exports.default = BaseFilter;